import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

function StepCircle({ stepItem, isActiveStep = false }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const circleSize = isMobile ? 30 : 50;
  const activeCircleSize = isMobile ? 50 : 70;

  const fontSize = isMobile ? 'subtitle2' : 'h6';
  const activeFontSize = isMobile ? 'subtitle1' : 'h5';

  return (
    <Box
      width={isActiveStep ? activeCircleSize : circleSize}
      height={isActiveStep ? activeCircleSize : circleSize}
      borderRadius='50%'
      backgroundColor={stepItem.completed ? 'primary.main' : 'grey.300'}
      display='flex'
      alignItems='center'
      justifyContent='center'
      fontWeight='bold'
      zIndex={1}
      marginTop={isMobile ? 0 : 3}
      sx={{
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      <Typography
        variant={isActiveStep ? activeFontSize : fontSize}
        fontWeight={isActiveStep ? 'bold' : 'normal'}
        color={stepItem.completed ? '#fff' : '#000'}
      >
        {stepItem.step}
      </Typography>
    </Box>
  )
}

function Step({ index, stepItem, isActiveStep, isLastStep, onSelectStep }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <React.Fragment>
      <Grid
        gridColumn={1}
        gridRow={index + 1}
        display='flex'
        justifyContent='center'
        position='relative'
        onClick={onSelectStep}
      >
        <StepCircle stepItem={stepItem} isActiveStep={isActiveStep} />
        {isMobile && (
          <Typography
            variant='body2'
            fontSize={isActiveStep ? 12 : 10}
            fontWeight={isActiveStep ? 'bold' : 'normal'}
            position='absolute'
            top={isActiveStep ? 55 : 35}
          >
            {stepItem.name}
          </Typography>
        )}
      </Grid>

      {isMobile && !isLastStep && (
        <Box
          display='flex'
          width='100%'
          marginLeft={1}
          marginRight={1}
          border='1px dashed'
          borderColor='grey.400'
        />
      )}

      {!isMobile && (
        <Grid
          gridColumn={2}
          gridRow={index + 1}
          paddingY={isActiveStep ? 2 : 0}
        >
          <StepContent
            stepItem={stepItem}
            isActiveStep={isActiveStep}
            isLastStep={isLastStep}
            onSelectStep={onSelectStep}
          />
        </Grid>
      )}
    </React.Fragment>
  )
}

function StepContent({ stepItem, isActiveStep, isLastStep, onSelectStep }) {
  return (
    <>
      <Typography
        variant={isActiveStep ? 'h5' : 'h6'}
        fontWeight='bold'
        color={stepItem.completed ? 'primary.main' : 'black'}
        marginTop={4}
      >
        {stepItem.title}
      </Typography>
      {stepItem.completed
        ? (
          <Box marginTop={2}>{stepItem.content}</Box>
        )
        : (
          <Box marginTop={2}>
            {isActiveStep ?
              stepItem.content :
              <>
                {stepItem.summary}
                {!isLastStep &&
                  <Typography
                    variant="body1"
                    marginTop={2}
                    onClick={onSelectStep}
                    sx={{ cursor: 'pointer' }}
                  >
                    <AddCircleOutlineIcon
                      fontSize='small'
                      style={{ verticalAlign: 'middle', marginRight: 4 }}
                    />
                    {"Ver detalhes"}
                  </Typography>
                }
              </>
            }
          </Box>
        )
      }
    </>
  )
}

export function MbResponsiveSteper({ steps = [], currentStepIndex }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [activeStepIndex, setActiveStepIndex] = useState(currentStepIndex);

  const handleStepSelection = (index) => {
    setActiveStepIndex(index)
  }

  useEffect(() => {
    handleStepSelection(currentStepIndex)
  }, [currentStepIndex])

  if (isMobile) {
    return (
      <Box>
        <Box
          display='flex'
          justifyContent='space-between'
          alignItems='center'
        >
          {steps.map((stepItem, index) => (
            <Step
              key={index}
              index={index}
              stepItem={stepItem}
              isLastStep={index === steps.length - 1}
              isActiveStep={index === activeStepIndex}
              onSelectStep={() => handleStepSelection(index)}
            />
          ))}
        </Box>

        <Box marginTop={8}>
          {steps[activeStepIndex] && (
            <StepContent
              stepItem={steps[activeStepIndex]}
              isActiveStep={true}
            />
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Box position='relative'>
      <Grid
        display='grid'
        gridTemplateColumns='auto 1fr'
        gap={4}
        position='relative'
      >
        {steps.map((stepItem, index) => (
          <Step
            key={index}
            index={index}
            stepItem={stepItem}
            isLastStep={index === steps.length - 1}
            isActiveStep={index === activeStepIndex}
            onSelectStep={() => handleStepSelection(index)}
          />
        ))}

        <Box
          position='absolute'
          top={35}
          left={activeStepIndex === undefined ? 25 : 35}
          width={0}
          height='100%'
          borderLeft='1px dashed'
          borderColor='grey.400'
          zIndex={0}
        />
      </Grid>
    </Box>
  );
}